
import useGetQueryPagination from "./helper/ueGetPagination";
import useAddMutation from "./helper/useAddMutation"
import useDeleteMutation from "./helper/useDeleteMutation"
import useGetOneQuery from "./helper/useGetOneQuery";
import useGetQuery from "./helper/useGetQuery"
import useGetSingleQuery from "./helper/useGetSingleQuery";
import useUpdateMutation from "./helper/useUpdateMutation";
import useUpdateMutationById from "./helper/useUpdateMutationById";
  
const API = {
  ADD: `attributeValue`,
  GET_ALL: `attributeValue`,

  DELETE: `attributeValue`,
  UPDATE: `attributeValue`,

};
const KEY = "attributeValue"


export const useGetAttributeValue = (params?:any) => useGetQueryPagination(KEY, API.GET_ALL,params);
export const useGetOneAttributeValue = (params?:any) => useGetOneQuery(KEY, API.GET_ALL,params);
export const useGetSingleAttributeValue = (params?:any) => useGetSingleQuery(KEY, API.GET_ALL,params);

export const useAddAttributeValue = () => useAddMutation(KEY, API.ADD);

export const useUpdateAttributeValue = () => useUpdateMutationById(KEY, API.UPDATE);
export const useUpdateAttributeValueStatus = () => useUpdateMutation(KEY, API.UPDATE);

export const useDeleteAttributeValue = () =>useDeleteMutation(KEY, API.DELETE);
